import { render } from "./RestaurantBooking.vue?vue&type=template&id=11913d94"
import script from "./RestaurantBooking.vue?vue&type=script&lang=js"
export * from "./RestaurantBooking.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Work\\项目\\点餐小程序\\ec-food-cardholder-t1-frontend-master\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__